import React from 'react';

import { Chip, Tooltip } from '@mui/material';

import { getPromoFeaturesConfig } from '@luxuryescapes/contract-svc-promo';

import { getPromoFeatureDisabledReason } from '~/components/Promo/promoFeatureDisabledReason';

import isProd from '~/utils/isProd';

export default function PromoAiEnvironmentNotice() {
  const feature = getPromoFeaturesConfig().features.find((item) => item.key === 'ai-promo-tools-access');
  const reason = getPromoFeatureDisabledReason(feature, isProd());

  if (reason?.kind !== 'environment') {
    return null;
  }

  return (
    <Tooltip title={reason.message}>
      <Chip label="Test only" size="small" variant="outlined" color="warning" aria-label={reason.message} />
    </Tooltip>
  );
}
